var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExclamationMark = function SvgExclamationMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 14,
    viewBox: "0 0 4 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.28 11.71a1.207 1.207 0 1 0 1.706 1.706 1.207 1.207 0 0 0-1.707-1.706ZM1.466 9.89h1.333V.555H1.466v9.333Z",
    fill: "#DD3737"
  })));
};
export { SvgExclamationMark as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNCIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDQgMTQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMS4yNzkxMyAxMS43MDk3QzAuODA3Nzk1IDEyLjE4MSAwLjgwNzc5NSAxMi45NDUgMS4yNzkxMyAxMy40MTY0QzEuNzUwNDYgMTMuODg3NyAyLjUxNDQ2IDEzLjg4NzcgMi45ODU4IDEzLjQxNjRDMy40NTcxMyAxMi45NDUgMy40NTcxMyAxMi4xODEgMi45ODU4IDExLjcwOTdDMi41MTQ0NiAxMS4yMzg0IDEuNzUwNDYgMTEuMjM4NCAxLjI3OTEzIDExLjcwOTdaIiBmaWxsPSIjREQzNzM3Ii8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMS40NjYgOS44ODkyNEgyLjc5OTM0VjAuNTU1OTA4SDEuNDY2VjkuODg5MjRaIiBmaWxsPSIjREQzNzM3Ii8+Cjwvc3ZnPgo=";